export default __webpack_public_path__ + "static/media/DZ.e495f2f6.svg";